import React, { useState, useEffect, useRef } from 'react';
import ResourceCard from './ResourcesCard';
import ResourcesStacked from './ResourcesStacked';
import { Grid } from "theme-ui";

const categories = [
  'All',
  'Academics',
  'Career',
  'Comp',
  'Scholarships',
];

const categoryStyle = (isActive) => ({
  cursor: 'pointer',
  padding: '10px 20px',
  borderRadius: '15px',
  margin: '0 10px',
  backgroundColor: isActive ? '#6E4884' : 'transparent',
  color: isActive ? 'white' : '#6E4884',
  fontSize: '1rem',
  fontWeight: 'bold',
});

const googleDocLinks = {
  'Academics': [
    { title: 'Getting Started in CS Research', link: 'https://docs.google.com/document/d/1yXiTQyFAuVYyWsJzdg_tWMGvE2_D-dGDvUkTeN-XYxY/edit?usp=drive_link' },
    { title: "Harvard Beginner's Guide to CS (2018 – 19)", link: 'https://docs.google.com/document/d/1adzsJdbrVeLC3k4_GJjLA9fTQqxhWEiW-v5wanG-YA8/edit#heading=h.32n2xboms2dq' },
    { title: 'WiCS Academic Support Guide', link: 'https://docs.google.com/document/d/1TBIQ2yjsN391yGq80ojFT7RItscaFP4INQwItfleuwQ/edit?usp=drive_link'},
    { title: 'WiCS Guide to Shopping Week (Fall 2020)', link: "https://docs.google.com/document/d/16d-fWvpVd9CwDN6AUk5RcMUIzX1glPgYOjMXvkxPsLI/edit?usp=drive_link"}
  ],
  'Career': [
    { title: 'WiCS Career Advice Notion Hub', link: "https://concrete-adapter-57c.notion.site/WiCS-Career-Resources-5341ddec10c1463a92ade85f3b1e524e?pvs=4"},
    { title: 'Endorsed Online Learning Resources', link: "https://docs.google.com/spreadsheets/d/10IQWNZqgqQutqO3yZu5IVe9YYVr12foB7A_x_iu5lh0/edit?usp=drive_link"},
    { title: 'Applying to Grad School 101', link: "https://docs.google.com/document/d/1b1-WnNtRNbOmyjnc2J5KabhMDEebgZF1GNettplEFQA/edit?usp=drive_link"},
    { title: 'Thinking About Grad School in CS or AM?', link: "https://drive.google.com/file/d/1MPwx9din619LBN4rz6rnYPJlZO3GSstp/view?usp=drive_link"},
    { title: 'Data Science 101', link: "https://docs.google.com/document/d/1egiuzwOELzwNwtHkTmG7Vfedpr8BarkbHT6_yrkFwio/edit?usp=drive_link"},
    { title: 'Fintech 101', link: "https://docs.google.com/document/d/1_8Elx67SeQKdpmjggKCFCQXl_-WhIewcMfOUsUpt_5c/edit?usp=drive_link"},
    { title: 'WiCS Technical Recruiting Guide (2019)', link: "https://docs.google.com/document/d/16HVtQ0bYrUdthIorEOS47w71rKh9WEGaa6wsj3OJr8o/edit?usp=drive_link"},
    { title: 'Freshman/Sophomore Internships', link: "https://docs.google.com/spreadsheets/d/1-EoMevOQTKqDEvl4l7KOi8WzlCATsf_r1lDQpORiqzE/edit?usp=drive_link"},
    { title: 'PM 101 Slide Deck #1', link: "https://docs.google.com/presentation/d/12eoz-HY-1pABul14EZdHHIpD_OS-goDvkdxyCi5g_cE/edit?usp=drive_link"},
    { title: 'PM 101 Slide Deck #2', link: "https://docs.google.com/presentation/d/1vJRXplDhh_SjrAOLE2PtbPcHXj3kfBtWMdI0cGuKFv0/edit?usp=drive_link"},
    { title: 'Getting Involved in Startups', link: "https://docs.google.com/document/d/1bjbJB2hbQgwfApg0mOYW32C1TCn6bybML34FI4OGLGY/edit?usp=drive_link"},
    { title: "Startups At Which We've Worked", link: "https://docs.google.com/document/d/1bjbJB2hbQgwfApg0mOYW32C1TCn6bybML34FI4OGLGY/edit?usp=drive_link"}
  ],
  'Comp': [
    { title: 'WiCS Comp Tracker', link: 'https://tinyurl.com/wicscompS26' },
    { title: 'Your Progress', link: '/Comp' }
  ],
  'Scholarships': [
    { title: 'External Resources & Opportunities', link: "https://docs.google.com/document/d/1jXYIyefJKVGAOC7GvreIa7nmmoOn_dR0dDHoHPnPehM/edit?usp=drive_link"},
    { title: 'Reimbursement Form', link: "https://docs.google.com/forms/d/e/1FAIpQLSef-4I1W94NWXPjp_wT2B23GtPLjyGy5mQyGbVsV8xVxDSclQ/viewform?usp=header"},
  ], 
};

const navStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '20px',
  marginBottom: '20px',
};

const Resources = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('cards'); // 'cards' or 'bars'

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const icons = ['./1st-icon.png', './2nd-icon.png', './3rd-icon.png'];

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (query.length > 0) {
      setActiveCategory(null);
    } else {
      setActiveCategory('All');
    }
  };

  const getFilteredLinks = () => {
    let links = [];
  
    if (searchQuery.length > 0) {
      links = Object.entries(googleDocLinks).flatMap(([category, links]) => 
        links
          .filter(link => link.title.toLowerCase().includes(searchQuery.toLowerCase()))
          .map(link => ({ ...link, category }))
      );
    } else if (activeCategory === 'All') {
      links = Object.values(googleDocLinks).flat();
    } else {
      links = googleDocLinks[activeCategory] || [];
    }
  
    return links;
  };

  const filteredLinks = getFilteredLinks();

  return (
    <div style={{ width: '100%', display: 'flex' }}>
      <div style={{ padding: '5%', width: '100%'}}>
        {/* Search bar and view toggle */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center' }}>
          <input
            type="text"
            placeholder="Search resources..."
            value={searchQuery}
            onChange={(e) => handleSearchChange(e)}
            style={{ 
              flex: 1,
              padding: '15px', 
              border: '1px solid #6E4884', 
              borderRadius: '20px', 
              color: 'grey', 
              boxShadow: '0px 0px 4px rgba(128, 128, 128, 0.5)', 
              fontFamily: 'Poppins', 
            }}
          />
          
          {/* View toggle buttons */}
          <div style={{ display: 'flex', gap: '5px', background: '#2a2a2a', borderRadius: '20px', padding: '5px' }}>
            <button
              onClick={() => setViewMode('cards')}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '15px',
                background: viewMode === 'cards' ? '#6E4884' : 'transparent',
                color: '#F9F9F9',
                cursor: 'pointer',
                fontFamily: 'Poppins',
                transition: 'all 0.3s ease',
              }}
            >
              Cards
            </button>
            <button
              onClick={() => setViewMode('bars')}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '15px',
                background: viewMode === 'bars' ? '#6E4884' : 'transparent',
                color: '#F9F9F9',
                cursor: 'pointer',
                fontFamily: 'Poppins',
                transition: 'all 0.3s ease',
              }}
            >
              Bars
            </button>
          </div>
        </div>

        <div style={navStyle}>
          {categories.map((category, index) => (
            <div key={index} style={{...categoryStyle(activeCategory === category), position: 'relative'}} onClick={() => handleCategoryClick(category)}>
              {category}
            </div>
          ))}
        </div>

        {/* Conditional rendering based on view mode */}
        {viewMode === 'cards' ? (
          <Grid columns={[1, 2]} sx={{ width: '100%', flexGrow: 1, justifyContent: 'center' }}>
            {filteredLinks.map((card, index) => (
              <ResourceCard
                key={index}
                title={card.title} 
                iconSrc={icons[Math.floor(index /2) % icons.length]}
                link={card.link}
              />
            ))}
          </Grid>
        ) : (
          <div style={{ padding: '20px 30px' }}>
            {filteredLinks.map((card, index) => (
              <ResourcesStacked
                key={index}
                title={card.title}
                iconSrc={icons[Math.floor(index /2) % icons.length]}
                link={card.link}
              />
            ))}
          </div>
        )}

        {/* Footer */}
        <footer className="site-footer" padding='5%'>
          <div className="container">
            <p>Icons provided by <a href="https://icons8.com" target="_blank" rel="noopener noreferrer">Icons8</a>.</p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Resources;